import { useEffect, useState, useMemo } from "react";
import DragDropTable from "../DnDTable";
import { getAccountsData } from "../../../../../apis/E-conomic/AccountsDataEconomicApi";
import { getEconomicSupplierListBulk } from "../../../../../apis/Business/EconomicSupplierBulk";

export const DnDParents = ({
  businessId,
  chosenYear,
  setContinueBinParents,
  allocatedYear,
  period,
  isEdit,
  submittedData,
}) => {
  const [mainData, setMainData] = useState([]);
  const [trashBin, setTrashBin] = useState([]);
  const [continueBin, setContinueBin] = useState([]);
  const [accountsData, setAccountsData] = useState([]);

  // Create grouped data
  const groupedData = useMemo(() => {
    const groups = mainData.reduce((acc, item) => {
      const key = item.account_number;
      if (!acc[key]) {
        acc[key] = {
          id: key,
          account_number: key,
          account_name: item.account_name,
          amount: 0,
          entries: 0,
          uniqueNames: new Set(),
          originalIds: [],
        };
      }
      acc[key].amount += parseFloat(item.amount);
      acc[key].entries += 1;
      acc[key].uniqueNames.add(item.account_name);
      acc[key].originalIds.push(item.id);
      return acc;
    }, {});

    const allGroups = Object.values(groups)
      .map((group) => ({
        ...group,
        uniqueNames: Array.from(group.uniqueNames),
      }))
      .sort((a, b) => a.account_number.localeCompare(b.account_number));

    // Remove items that are present in groupedContinueData
    if (submittedData && submittedData.length > 0) {
      const submittedKeys = new Set(
        submittedData.map((item) => item.account_number)
      );
      return allGroups.filter(
        (group) => !submittedKeys.has(group.account_number)
      );
    }

    return allGroups;
  }, [mainData, submittedData]);

  const groupedContinueData = useMemo(() => {
    if (!isEdit) return [];

    const groups = submittedData.reduce((acc, item) => {
      const key = item.account_number;
      if (!acc[key]) {
        acc[key] = {
          id: key,
          account_number: key,
          account_name: item.account_name,
          amount: 0,
          entries: 0,
          uniqueNames: new Set(),
          originalIds: [],
        };
      }
      acc[key].amount += parseFloat(item.amount);
      acc[key].entries += 1;
      acc[key].uniqueNames.add(item.account_name);
      acc[key].originalIds.push(item.id);
      return acc;
    }, {});

    return Object.values(groups)
      .map((group) => ({
        ...group,
        uniqueNames: Array.from(group.uniqueNames),
      }))
      .sort((a, b) => a.account_number.localeCompare(b.account_number));
  }, [submittedData, isEdit]);

  useEffect(() => {
    getEconomicSupplierListBulk({
      businessId,
      setObjects: setMainData,
      year: chosenYear,
      allocatedYear: allocatedYear,
      period: period,
    });
    getAccountsData({ setAccounts: setAccountsData });
  }, [businessId, chosenYear, allocatedYear, period]);

  const handleUpdateData = (newData) => {
    setMainData(newData);
  };

  const handleMoveToTrash = (item) => {
    setTrashBin((prev) => [...prev, item]);
  };

  const handleMoveToContinue = (item) => {
    const selectedItem = { ...item, is_selected: true };

    setContinueBinParents((prev) => [...prev, selectedItem]);
    setContinueBin((prev) => [...prev, selectedItem]);
  };

  return (
    <DragDropTable
      data={mainData}
      groupedData={groupedData}
      onUpdateData={handleUpdateData}
      onMoveToTrash={handleMoveToTrash}
      onMoveToContinue={handleMoveToContinue}
      defaultGrouped={true}
      continueBin={groupedContinueData}
    />
  );
};
